import { getParameterByName } from "../../utils";

class Auth {
  static shared = new Auth();

  getToken(): string | null {
    const tokenInURL = getParameterByName("pax_check_token");

    if (tokenInURL) {
      this.saveToken(tokenInURL);
      return tokenInURL;
    }

    return this.loadToken();
  }

  private saveToken(token: string) {
    localStorage.setItem("access_token", token);
  }

  private loadToken(): string | null {
    return localStorage.getItem("access_token");
  }
}

export default Auth;
